export default __webpack_public_path__ + "static/media/location-chicago.007d39b1.jpg";